
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Prop, Vue } from "vue-property-decorator";
import { Modal } from "bootstrap";
import HazardListItem from "../components/HazardListItem.vue";
import MapTile from "../components/MapTile.vue";
import QrCode from "../components/QRCode.vue";
import ArcgisAuthenticate from "../utils/ArcgisAuthenticate";
import { parseInt } from "lodash";

const arcgisAuthenticate = new ArcgisAuthenticate();

@Component({
  components: {
    HazardListItem,
    MapTile,
    QrCode
  }
})
export default class HazardListScreen extends Vue {
  @Prop()
  hazardSiteList!: any;
  @Prop()
  hazardRouteList!: any;
  @Prop()
  defaultLocationList!: Record<string, string | number[]>[];
  @Prop()
  selectedLocation!: Record<string, string | number[]>;
  @Prop()
  accuracy!: number;
  @Prop()
  noti!: number;
  @Prop()
  workOrder!: number;
  @Prop()
  route!: number[][];
  @Prop()
  trackPath!: number[][];
  @Prop()
  endCoords!: number[];
  @Prop()
  otherTracks!: number[][];
  @Prop({})
  accessPoints!: number[][];
  @Prop({})
  defibrillators!: number[][];
  @Prop({})
  customersRetrieved!: boolean;

  $refs!: {
    screenMap: MapTile;
  };

  private retrievingCustomerData = false;
  private errorMessage = "";
  private confirmModal!: Modal;
  private errorModal!: Modal;

  mounted() {
    this.confirmModal = new Modal(
      document.getElementById("request-customer-details-modal") as HTMLElement
    );
    this.errorModal = new Modal(
      document.getElementById("customer-details-error-modal") as HTMLElement
    );
  }

  private updateLocation(location: string) {
    this.$emit("update-location", location);
  }

  private getCustomerDataCount(): number {
    const customerDataDialogCountString =
      arcgisAuthenticate.getCookie("customer_data_dialog_count") || "0";
    return parseInt(customerDataDialogCountString);
  }

  private openCustomerDialog() {
    const customerDataDialogCount = this.getCustomerDataCount();
    if (customerDataDialogCount > 0) {
      this.confirm();
    } else {
      this.confirmModal.show();
    }
  }

  private confirm() {
    this.retrievingCustomerData = true;
    this.$emit("retrieve-customers", (error = "") => {
      this.confirmModal.hide();
      this.retrievingCustomerData = false;
      if (error) {
        this.errorMessage = error;
        this.errorModal.show();
      } else {
        let customerDataDialogCount = this.getCustomerDataCount();
        customerDataDialogCount += 1;
        if (customerDataDialogCount > 10) customerDataDialogCount = 0;
        arcgisAuthenticate.setCookie(
          "customer_data_dialog_count",
          customerDataDialogCount.toString()
        );
      }
    });
  }
}
